export default {
  setRoute (state: {[key:string]: string}, value: string) {
    state.route = value
  },
  setErrorFlag (state:any, flag: boolean) {
    state.errorFlag = flag
  },
  setTimeoutErrorFlag (state:any, flag: boolean) {
    state.timeoutErrorFlag = flag
  }
}
